import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Classes from "./styles/style.module.css";
import MenuIcon from "../../images/icons/menu.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ChevronLeft from "../../images/icons/chevronLeft.svg";
import {
  setShowRegister,
  setRegisterCurrentStep,
} from "../../redux/actions/User";
import {
  setShowCheatModal,
  setShowFinalizeModal,
  setShowWordGameHintModal,
} from "../../redux/actions/Quiz";
import JoftPoochLogo from "../../images/logo/joftPoochLogo.png";
import BellIcon from "../../images/icons/bellIcon.svg";
import ChartIcon from "../../images/icons/ChartIcon.svg";
import { GoArrowLeft } from "react-icons/go";
import FinishIcon from "../../images/icons/finishIcon.svg";
import MessageQustionIcon from "../../images/icons/message-question.svg";
import useHomeAddress from "../../Hooks/getHomeAddress";
import { FiMenu } from "react-icons/fi";
import RCoin from "../../images/icons/RCoin.png";

const HeaderMobile = (props) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showRegister, registerCurrStep, currentUser, userPoint } =
    useSelector(({ user }) => user);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const query = queryParams.get("type");
  const { homeAddress } = useHomeAddress();

  const getPathName = (pathName) => {
    if (/^\/reportcard\/[^/]+\/?$/.test(pathName)) return "کارنامه";
    if (pathName.match(/\/events\/(\d+)/)) {
      return "لیست سانس ها";
    } else if (pathName.match(/\/ticket\/(\d+)/)) {
      return "بلیط";
    } else if (pathName.match(/\/formQR\/(\d+)/)) {
      return "نتیجه ثبت";
    } else if (pathname.match(/\/questions\/(\d+)/)) {
      return "چالش ها";
    } else if (pathname.match(/\/khazane\/(\d+)/)) {
      return "خزانه";
    } else if (pathname.match(/\/form\/(\d+)/)) {
      return "پر کردن فرم";
    } else if (pathname.match(/\/pointShopDetails\/(\d+)/)) {
      return "اطلاعات جایزه";
    } else if (pathname.match(/\/awardReceipt\/(\d+)/)) {
      return "رسید جایزه";
    } else if (pathname.match(/\/scoreHistory\/(\d+)/)) {
      return "تاریخچه پله‌ها";
    } else if (pathname.match(/\/eventDetails\/(\d+)/)) {
      return "جزئیات رخداد";
    } else if (pathName.match(/\/createdTicket\/(\d+)/)) {
      return "ثبت تیکت";
    } else if (pathName.match(/\/eventWordGame\/(\d+)/)) {
      return "کلمه بازی";
    } else {
      switch (pathName) {
        case "/dashboard":
          return "پیشخوان";
        case "/":
          return "اعلان ها";
        case "/blog":
          return "اخبار";
        case "/profile":
          return "کاربر";
        case "/user/update":
          return "ویرایش اطلاعات";
        case "/gallery":
          return "گزارش تصویری";
        case "/events":
          return "رخداد ها";
        case "/archive":
          return "پرونده ها";
        case "/leaderboard":
          return "جدول پیشتازان";
        case "/scoreHistory":
          return "تاریخچه پله‌ها";
        case "/quests":
          return "ماموریت‌ها";
        case "/login":
          return "";
        case "/fortuneWheel":
          return "گردونه شانس";
        case "/roshana":
          return "روشنا";
        case "/mRoshana":
          return "روشنا";
        case "/rb1403":
          return "راه‌بهشت 1403";
        case "/rb1403/catalog":
          return "راه‌بهشت 1403";
        case "/forms":
          return "فرم‌ها";
        case "/reportcards":
          return "کارنامه ها";
        case "/wordGamesList":
          return "کلمه بازی ها";
        case "/goldenCard":
          return "کارت طلایی";
        case "/pointshop":
          return "ویترین جوایز";
        case "/purchaselist":
          return "سابقه خرید ها";
        case "/transactions":
          return "تراکنش ها";
        case "/createTicket":
          return "ثبت تیکت";
        case "/peleBaroon":
          return "پله بارون";
        default:
          return "راه بهشت";
      }
    }
  };

  const backAction = () => {
    if (pathname === "/login") {
      if (registerCurrStep === 0 && !showRegister) {
        navigate(homeAddress, { replace: true });
      } else if (registerCurrStep === 0 && showRegister) {
        dispatch(setShowRegister(false));
      } else if (registerCurrStep !== 0 && showRegister) {
        dispatch(setRegisterCurrentStep(0));
      } else navigate(homeAddress, { replace: true });
    } else {
      navigate(-1);
    }
  };

  const mainHeader = (
    <div className={Classes.mobileHeader}>
      <div
        className={`row align-items-center py-2 ${
          pathname === "/lig/map" ? "text-white" : ""
        }`}
      >
        <div className="col-3 text-right" onClick={props.sideBarToggler}>
          {pathname === "/lig/map" ? (
            <FiMenu color="#fff" size={25} />
          ) : (
            <img src={MenuIcon} alt="menuIcon" />
          )}
        </div>
        <div className="col-6">
          <p className={Classes.headerTitle}>{getPathName(pathname)}</p>
        </div>
        <div className="col-3">
          <div
            className={`${Classes.poinContainer} justify-content-end`}
            onClick={() => navigate("/pointshop")}
          >
            <span className="m-0">{userPoint}</span>
            <img src={RCoin} alt="coin" className="mr-2 ml-0" />
          </div>
        </div>
      </div>
    </div>
  );

  const secondaryHeader = (
    <div className={Classes.mobileHeader}>
      <div className="row align-items-center py-2 mt-3">
        <div className={pathname === "/login" ? "col-6 text-right" : "col-3"}>
          {pathname === "/login" ? (
            <p
              className={Classes.helpText}
              onClick={() =>
                window.open("https://eitaa.com/msc_cul_admin", "_blank")
              }
            >
              کمک نیاز دارید؟
            </p>
          ) : null}
        </div>
        <div className={pathname === "/login" ? "col-3" : "col-6"}>
          <p className={Classes.secondary_header_title}>
            {getPathName(pathname)}
          </p>
        </div>
        <div className="col-3 d-flex justify-content-end">
          <div className={Classes.backButton} onClick={backAction}>
            <img src={ChevronLeft} alt="chevron-left" />
          </div>
        </div>
      </div>
    </div>
  );

  const pointShopHeader = (
    <div className={Classes.mobileHeader}>
      <div className="row align-items-center py-2 mt-3">
        <div className={"col-3 justify-content-start"}>
          <div
            className={Classes.poinContainer}
            onClick={() => {
              if (pathname !== "/pointshop") {
                navigate("/pointshop");
              }
            }}
          >
            <img src={RCoin} alt="coin" />
            <span>{userPoint}</span>
          </div>
        </div>
        <div className={"col-6"}>
          <p className={Classes.secondary_header_title}>
            {getPathName(pathname)}
          </p>
        </div>
        <div className="col-3 d-flex justify-content-end">
          <div className={Classes.backButton} onClick={backAction}>
            <img src={ChevronLeft} alt="chevron-left" />
          </div>
        </div>
      </div>
    </div>
  );

  const joftPoochMenu = (
    <div className={Classes.mobileHeader}>
      <div className="row align-items-center py-2 mt-3">
        <div className="col-6 text-right">
          <img
            src={JoftPoochLogo}
            alt="joftPoochLogo"
            className={Classes.matchLogo}
          />
        </div>
        <div className="col-6">
          <div className={Classes.matchMenuIconContainer}>
            <img
              src={ChartIcon}
              alt="chartIcon"
              onClick={() => navigate("/leaderboard")}
            />
            <img
              src={BellIcon}
              alt="bellIcon"
              onClick={() => navigate(homeAddress)}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const ThirdHeader = (
    <div className={Classes.mobileHeader}>
      <div className="row align-items-center py-2 mt-3">
        <div className="col-6 text-right">
          <p className={Classes.thirdHeaderTitle}>{getPathName(pathname)}</p>
        </div>
        <div className="col-6">
          <div className={Classes.matchMenuIconContainer}>
            <img
              src={ChartIcon}
              alt="chartIcon"
              onClick={() => navigate("/leaderboard")}
            />
            <GoArrowLeft size={25} onClick={() => navigate(-1)} />
          </div>
        </div>
      </div>
    </div>
  );

  const LeaderBoardHeader = (
    <div className={Classes.lbmobileHeader}>
      <div className="row align-items-center px-0 mx-0 py-3">
        <div className="col-6 px-0 mx-0  text-right">
          <p className={Classes.lbHeaderTitle}>{getPathName(pathname)}</p>
        </div>
        <div className="col-6 px-0 mx-0 text-left">
          <GoArrowLeft size={25} color="#fff" onClick={() => navigate(-1)} />
        </div>
      </div>
    </div>
  );

  const QuestionsHeader = (
    <div className={Classes.matchHeader}>
      <div className="row align-items-center px-0 mx-0 py-3">
        <div className="col-9 px-0 mx-0  text-right">
          <p className={Classes.matchHeaderTitle}>{getPathName(pathname)}</p>
        </div>
        <div className="col-3 px-0 mx-0 text-left d-flex justify-content-between">
          <img
            src={MessageQustionIcon}
            alt="helpIcon"
            onClick={() => dispatch(setShowCheatModal(true))}
          />
          <img
            src={FinishIcon}
            alt="finishIcon"
            onClick={() => dispatch(setShowFinalizeModal(true))}
          />
        </div>
      </div>
    </div>
  );

  const QuestionHeader = (
    <div className={Classes.matchHeader}>
      <div className="row align-items-center px-0 mx-0 py-3">
        <div className="col-9 px-0 mx-0  text-right">
          <p className={Classes.matchHeaderTitle}>{`سوال  ${query}`}</p>
        </div>
        <div className="col-3 px-0 mx-0 text-left d-flex justify-content-between">
          <img
            src={MessageQustionIcon}
            alt="helpIcon"
            onClick={() => dispatch(setShowCheatModal(true))}
          />
          <img
            src={FinishIcon}
            alt="finishIcon"
            onClick={() => dispatch(setShowFinalizeModal(true))}
          />
        </div>
      </div>
    </div>
  );

  const wordGameHeader = (
    <div className={Classes.mobileHeader}>
      <div className="row align-items-center py-2 mt-3">
        <div className="col-6 text-right">
          <p className={Classes.thirdHeaderTitle}>کلمه بازی</p>
        </div>
        <div className="col-6">
          <div>
            <img
              src={"/images/wordGame/info-circle.svg"}
              alt="hintIcon"
              className="pointer"
              onClick={() => dispatch(setShowWordGameHintModal(true))}
            />
          </div>
        </div>
      </div>
    </div>
  );

  if (
    [
      "/profile",
      "/user/update",
      "/gallery",
      "/events",
      "/forms",
      "/reportcards",
      "/login",
      "/createTicket",
      "/peleBaroon",
      "/wordGamesList",
    ].includes(pathname) ||
    /^\/reportcard\/[^/]+\/?$/.test(pathname) ||
    pathname.match(/\/events\/(\d+)/) ||
    pathname.match(/\/createdTicket\/(\d+)/) ||
    pathname.match(/\/eventDetails\/(\d+)/) ||
    pathname.match(/\/form\/(\d+)/) ||
    pathname.match(/\/ticket\/(\d+)/) ||
    pathname.match(/\/formQR\/(\d+)/)
  ) {
    return secondaryHeader;
  } else if (
    pathname === "/match" ||
    pathname.match(/\/match\/(\d+)/) ||
    pathname === "/preMatch" ||
    pathname.match(/\/preMatch\/(\d+)/)
  ) {
    return joftPoochMenu;
  } else if (
    pathname === "/leaderboard" ||
    pathname === "/scoreHistory" ||
    pathname === "/goldenCard" ||
    pathname.match(/\/scoreHistory\/(\d+)/)
  ) {
    return LeaderBoardHeader;
  } else if (pathname.match(/\/questions\/(\d+)/)) {
    return QuestionsHeader;
  } else if (pathname.match(/\/question\/(\d+)/)) {
    return QuestionHeader;
  } else if (
    pathname === "/quests" ||
    pathname === "/fortuneWheel" ||
    pathname.match(/\/khazane\/(\d+)/)
  ) {
    return ThirdHeader;
  } else if (
    pathname === "/pointshop" ||
    pathname.match(/\/pointShopDetails\/(\d+)/) ||
    pathname.match(/\/awardReceipt\/(\d+)/) ||
    pathname === "/purchaselist" ||
    pathname === "/transactions"
  ) {
    return pointShopHeader;
  } else if (
    pathname === "/hubble" ||
    pathname === "/hubble/scoreBoard" ||
    pathname === "/hubble/blog" ||
    pathname === "/hubble/map" ||
    pathname === "/hubble/upload" ||
    pathname === "/hubble/majors" ||
    pathname === "/hubble/myUploads" ||
    pathname === "/hubble/compressEd" ||
    pathname === "/hubble/UploadsArbitration" ||
    pathname.match(/\/hubble\/upload\/edit\/[\da-fA-F]+/) ||
    pathname.match(/\/hubble\/judge\/[\da-fA-F]+/)
  ) {
    return null;
  } else if (
    pathname === "/wordGame" ||
    pathname.match(/\/wordGame\/[\da-fA-F]+/)
  ) {
    return wordGameHeader;
  } else return mainHeader;
};

export default HeaderMobile;
